export const SET_WALLBOARDS = 'SET_WALLBOARDS'
export const RESET_WALLBOARDS = 'RESET_WALLBOARDS'

export default {
    SET_WALLBOARDS,
    RESET_WALLBOARDS
}
